import { cn } from '@/lib/utils';

/**
 * Bloco base de skeleton (placeholder de carregamento).
 * `animate-pulse` + token `muted`; respeita prefers-reduced-motion.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted motion-reduce:animate-none', className)}
      aria-hidden="true"
      {...props}
    />
  );
}
